export default function SkillsController() {}
